exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic[data-v-7913381e] {\n  font-size: 14px;\n  line-height: 20px;\n}\n.select-area[data-v-7913381e] {\n  margin: 20px;\n}\n", ""]);

// exports
